import React from 'react';
import PropTypes from 'prop-types';

export const StatusQuote = ({ status, strings }) => {
  let label;
  switch (status) {
    case 'submitted':
      label = strings['quotations.filter.status.options.submitted.label'] || 'Submitted';
      break;
    case 'canceled':
      label = strings['quotations.filter.status.options.canceled.label'] || 'Canceled';
      break;
    case 'project':
      label = strings['quotations.filter.status.options.project.label'] || 'Project';
      break;
    case 'pending':
      label = strings['quotations.filter.status.options.pending.label'] || 'Pending';
      break;

    default:
      label = status;
      break;
  }

  return (
    <>
      <div
        className={`status-inline-block ${status}`}
        style={{
          alignItems: 'center',
          justifyContent: 'left',
          display: 'inline-flex',
          alignSelf: 'center',
          marginLeft: '5px',
          padding: '0px 10px',
        }}
      >
        <div className={`status ship2 ${status}`} />
        <div className={`status label ${status}`}>{label}</div>
        {/* <div
          style={{
            backgroundColor: color,
            padding: '0',
            fontSize: '0.875rem',
            height: '10px',
            width: '10px',
            borderRadius: '50px'
          }}
        />
        <span style={{ color, padding: '8px 4px', fontSize: '0.875rem' }}>{label}</span> */}
      </div>
    </>
  );
};

StatusQuote.propTypes = {
  status: PropTypes.string.isRequired,
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
};
